import * as Yup from 'yup';

export const ZONE_NAME_PATTERN = /^[A-Za-z0-9_]+$/;

export const zoneNameRule = Yup.string()
  .required('Zone name is required')
  .matches(ZONE_NAME_PATTERN, 'Only letters, digits and _ are allowed');
